export default function Contact() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            片源投稿、问题反馈、广告合作，欢迎随时联系我们
          </p>
          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-accent-600"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">片源投稿</p>
                <p className="text-sm font-medium text-foreground-800">submit@97cinema.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-question-answer-line text-xl text-primary-600"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">问题反馈</p>
                <p className="text-sm font-medium text-foreground-800">feedback@97cinema.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-team-line text-xl text-secondary-600"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">广告合作</p>
                <p className="text-sm font-medium text-foreground-800">ads@97cinema.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}